export const ORDER_STATUSES = {
  APPROVED: 'approved',
  BOOKED: 'booked',
  CANCELED: 'canceled',
  CONFIRMED: 'confirmed',
  CREATED: 'created',
  DEPOSIT: 'deposit',
  DOCUMENTS_SENT: 'documents_sent',
  FLIGHT_CONFIRMED: 'flight_confirmed',
  GOT_BACK: 'got_back',
  NOT_CONFIRMED: 'not_confirmed',
  ON_TRIP: 'on_trip',
  PAID: 'paid',
  SURVEY_COMPLETED: 'survey_completed',
  ANNULLED: 'annulled',
};
